import state from '@/vuex/busca-documentos/state.js'
import getters from '@/vuex/busca-documentos/getters.js'
import mutations from '@/vuex/busca-documentos/mutations.js'
import actions from '@/vuex/busca-documentos/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
